import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import _regeneratorRuntime from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es6.array.find-index";
import _defineProperty from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getAuthUser, updateAuthUser, getOrganizationUsers, storeOrganizationUser, updateOrgUser, deleteOrganizationUser, getMembers, storeMember, updateMember, deleteMember, getParticipants, storeParticipant, updateParticipant, deleteParticipant, getOrganizationUsersInGroup } from "src/models/User";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
import errorDialog from "src/functions/function-show-error-message";
import getErrorPayload from "src/functions/get-error-payload";
import { commitPagination, hasNextPage } from "src/store/utils/pagination";
import { searchByInput } from "src/functions/search-input"; // Init state

var initState = function initState() {
  return {
    authUser: {},
    user: {},
    users: [],
    newUser: {
      name: "",
      email: "",
      admin: false,
      groups: []
    },
    searchUserInput: "",
    member: {},
    members: [],
    membersPagination: {
      currentPage: 0,
      total_pages: 1
    },
    hasMoreMembers: true,
    usersPagination: {
      currentPage: 0,
      total_pages: 1
    },
    hasMoreUsers: true,
    participants: [],
    loading: {
      participants: false,
      users: false,
      members: false
    }
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  setAuthUser: function setAuthUser(state, payload) {
    state.authUser = payload;
  },
  setNewUser: function setNewUser(state, payload) {
    var propertyName = Object.keys(payload)[0];
    var newValue = payload[propertyName];

    if (propertyName === "group") {
      state.newUser.groups = state.newUser.groups.map(function (group) {
        if (group.id === newValue.id) {
          return _objectSpread(_objectSpread({}, group), {}, {
            group_role: newValue.group_role
          });
        }

        return group;
      });
    } else {
      state.newUser[propertyName] = newValue;
    }
  },
  resetNewUser: function resetNewUser(state) {
    state.newUser = initState().newUser;
  },
  setAllNewUserGroups: function setAllNewUserGroups(state) {
    if (_.isEmpty(state.newUser.groups)) {
      state.newUser.groups = this.getters["Group/organizationGroups"].map(function (group) {
        return _objectSpread(_objectSpread({}, group), {}, {
          group_role: null
        });
      });
    }
  },
  setOrganizationUser: function setOrganizationUser(state, payload) {
    state.user = payload;
  },
  setOrganizationUsers: function setOrganizationUsers(state, payload) {
    var dedupedUsers = payload.filter(function (user, index, arr) {
      return arr.findIndex(function (item) {
        return item.id === user.id;
      }) === index;
    });
    state.users = dedupedUsers;
  },
  updateOrganizationUser: function updateOrganizationUser(state, payload) {
    console.log(payload);
  },
  setOrganizationUsersInGroup: function setOrganizationUsersInGroup(state, payload) {
    state.users = payload;
  },
  removeOrgUser: function removeOrgUser(state, id) {
    state.users = state.users.filter(function (user) {
      return user.id !== id;
    });
  },
  updateSearchUserInput: function updateSearchUserInput(state, value) {
    state.searchUserInput = value;
  },
  setUserGroupRole: function setUserGroupRole(state, payload) {
    // Find the index of the user with the matching user_id
    var userIndex = state.users.findIndex(function (user) {
      return user.id === payload.user_id;
    }); // Check if the user was found

    if (userIndex !== -1) {
      // Find the index of the group with the matching group_id
      var groupIndex = state.users[userIndex].userGroups.data.findIndex(function (group) {
        return group.id === payload.group_id;
      }); // Check if the group was found

      if (groupIndex !== -1) {
        // Update the group_role property of that group with the value from the payload
        state.users[userIndex].userGroups.data[groupIndex].group_role = payload.group_role;
      }
    }
  },
  setMembers: function setMembers(state, payload) {
    state.members = payload;
  },
  appendMembers: function appendMembers(state, payload) {
    state.members = [].concat(_toConsumableArray(state.members), _toConsumableArray(payload));
  },
  updateMembersPagination: function updateMembersPagination(state, pagination) {
    state.membersPagination.currentPage = pagination.currentPage;
    state.membersPagination.total_pages = pagination.total_pages;
  },
  setHasMoreMembers: function setHasMoreMembers(state, value) {
    state.hasMoreMembers = value;
  },
  appendUsers: function appendUsers(state, payload) {
    var existingIds = new Set(state.users.map(function (user) {
      return user.id;
    }));
    var newUsers = payload.filter(function (user) {
      return !existingIds.has(user.id);
    });
    state.users = [].concat(_toConsumableArray(state.users), _toConsumableArray(newUsers));
  },
  updateUsersPagination: function updateUsersPagination(state, pagination) {
    state.usersPagination.currentPage = pagination.currentPage;
    state.usersPagination.total_pages = pagination.total_pages;
  },
  setHasMoreUsers: function setHasMoreUsers(state, value) {
    state.hasMoreUsers = value;
  },
  setMember: function setMember(state, payload) {
    state.member = payload;
  },
  setMeetingParticipants: function setMeetingParticipants(state, payload) {
    state.participants = payload ? payload : [];
  },
  removeParticipant: function removeParticipant(state, payload) {
    state.participants = state.participants.filter(function (participant) {
      return participant.email !== payload.email;
    });
  },
  removeMember: function removeMember(state, id) {
    state.members = state.members.filter(function (member) {
      return member.id !== id;
    });
  },
  setParticipantsLoading: function setParticipantsLoading(state, payload) {
    state.loading.participants = payload;
  },
  setUsersLoading: function setUsersLoading(state, payload) {
    state.loading.users = payload;
  },
  setMembersLoading: function setMembersLoading(state, payload) {
    state.loading.members = payload;
  },
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  // Auth User
  fetchAuthUser: function fetchAuthUser(_ref) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.prev = 1;
              _context.next = 4;
              return getAuthUser();

            case 4:
              response = _context.sent;
              commit("setAuthUser", response.data);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.log("error: ", _context.t0.response);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }))();
  },
  updateAuthUserProfile: function updateAuthUserProfile(_ref2, request) {
    var state = _ref2.state;
    return new Promise(function (resolve, reject) {
      updateAuthUser(state.authUser.id, request).then(function () {
        resolve();
      }).catch(function (error) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(error));
        console.log("error.response: ", error.response);
        reject();
      });
    });
  },
  // Organization Users
  fetchOrganizationUsers: function fetchOrganizationUsers(_ref3, organizationId) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        state = _ref3.state;
    commit("setUsersLoading", true);
    commit("setHasMoreUsers", true);
    var orgId = _.isEmpty(organizationId) ? this.getters["Organization/organization"].id : organizationId;
    return new Promise( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
        var _response$data, _response$data$users, _response$data$users$, response, dataCopy;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getOrganizationUsers(orgId, 1);

              case 3:
                response = _context2.sent;
                dataCopy = _objectSpread({}, response.data);
                delete dataCopy.users;
                commit("Organization/setOrganization", dataCopy, {
                  root: true
                });
                _context2.next = 9;
                return dispatch("setMissingGroupsInUserGroups", response.data);

              case 9:
                commit("Group/setOrganizationGroups", response.data.groups.data, {
                  root: true
                });

                if ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$users = _response$data.users) === null || _response$data$users === void 0 ? void 0 : (_response$data$users$ = _response$data$users.meta) === null || _response$data$users$ === void 0 ? void 0 : _response$data$users$.pagination) {
                  commit("updateUsersPagination", {
                    currentPage: response.data.users.meta.pagination.current_page,
                    total_pages: response.data.users.meta.pagination.total_pages
                  });

                  if (response.data.users.meta.pagination.current_page >= response.data.users.meta.pagination.total_pages) {
                    commit("setHasMoreUsers", false);
                  }
                } else {
                  commit("setHasMoreUsers", false);
                }

                commit("setUsersLoading", false);
                resolve();
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](0);
                errorDialog.showErrorMessageFromServer(getErrorPayload(_context2.t0));
                commit("setUsersLoading", false);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 15]]);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
  },
  fetchMoreOrganizationUsers: function fetchMoreOrganizationUsers(_ref5) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, dispatch, state, orgId, nextPage, _response$data2, _response$data2$users, _response$data2$users2, response;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit, dispatch = _ref5.dispatch, state = _ref5.state;
              orgId = _this.getters["Organization/organization"].id;

              if (!state.loading.users) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              if (hasNextPage(state, "usersPagination")) {
                _context3.next = 7;
                break;
              }

              commit("setHasMoreUsers", false);
              return _context3.abrupt("return");

            case 7:
              commit("setUsersLoading", true);
              nextPage = state.usersPagination.currentPage + 1;
              _context3.prev = 9;
              _context3.next = 12;
              return getOrganizationUsers(orgId, nextPage);

            case 12:
              response = _context3.sent;
              _context3.next = 15;
              return dispatch("appendMissingGroupsInUserGroups", response.data);

            case 15:
              commitPagination(commit, (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$users = _response$data2.users) === null || _response$data2$users === void 0 ? void 0 : (_response$data2$users2 = _response$data2$users.meta) === null || _response$data2$users2 === void 0 ? void 0 : _response$data2$users2.pagination, {
                update: "updateUsersPagination",
                setHasMore: "setHasMoreUsers"
              });
              commit("setUsersLoading", false);
              _context3.next = 23;
              break;

            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](9);
              errorDialog.showErrorMessageFromServer(getErrorPayload(_context3.t0));
              commit("setUsersLoading", false);

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[9, 19]]);
    }))();
  },
  setMissingGroupsInUserGroups: function setMissingGroupsInUserGroups(_ref6, payload) {
    var commit = _ref6.commit;
    // Sets the missing groups in the userGroups with null values.
    var users = payload.users.data.map(function (user) {
      var userGroups = payload.groups.data.map(function (group) {
        var existingGroup = user.userGroups.data.find(function (userGroup) {
          return userGroup.id === group.id;
        });
        return existingGroup ? existingGroup : {
          id: group.id,
          name: group.name,
          group_role: null
        };
      });
      return _objectSpread(_objectSpread({}, user), {}, {
        userGroups: {
          data: userGroups
        }
      });
    });
    commit("setOrganizationUsers", users);
  },
  appendMissingGroupsInUserGroups: function appendMissingGroupsInUserGroups(_ref7, payload) {
    var commit = _ref7.commit,
        state = _ref7.state;
    var users = payload.users.data.map(function (user) {
      var userGroups = payload.groups.data.map(function (group) {
        var existingGroup = user.userGroups.data.find(function (userGroup) {
          return userGroup.id === group.id;
        });
        return existingGroup ? existingGroup : {
          id: group.id,
          name: group.name,
          group_role: null
        };
      });
      return _objectSpread(_objectSpread({}, user), {}, {
        userGroups: {
          data: userGroups
        }
      });
    });
    commit("appendUsers", users);
  },
  fetchOrganizationUsersInGroup: function fetchOrganizationUsersInGroup(_ref8) {
    var commit = _ref8.commit;
    var groupId = this.getters["Group/group"].id;
    return new Promise(function (resolve) {
      getOrganizationUsersInGroup(groupId).then(function (response) {
        commit("setOrganizationUsersInGroup", response.data.data);
        resolve();
      }).catch(function (e) {
        console.log(e.reponse);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  createOrganizationUser: function createOrganizationUser(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state;
    var organization = this.getters["Organization/organization"];
    return new Promise(function (resolve) {
      storeOrganizationUser(organization.id, state.newUser).then(function () {
        commit("resetNewUser");
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  updateOrganizationUser: function updateOrganizationUser(_ref10, request) {
    var commit = _ref10.commit;
    commit("setUsersLoading", true);
    var organization = this.getters["Organization/organization"];
    var userId = request["id"];
    return new Promise(function (resolve) {
      updateOrgUser(organization.id, userId, request).then(function () {
        commit("setUsersLoading", false);
        resolve();
      }).catch(function (e) {
        console.log(getErrorPayload(e));
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setUsersLoading", false);
      });
    });
  },
  removeOrganizationUser: function removeOrganizationUser(_ref11, userId) {
    var commit = _ref11.commit;
    var organization = this.getters["Organization/organization"];
    commit("setUsersLoading", true);
    return new Promise(function (resolve, reject) {
      deleteOrganizationUser(organization.id, userId).then(function () {
        commit("removeOrgUser", userId);
        commit("setUsersLoading", false);
        resolve();
      }).catch(function (e) {
        commit("setUsersLoading", false);
        reject();
      });
    });
  },
  // Members
  fetchMembers: function fetchMembers(_ref12) {
    var commit = _ref12.commit;
    commit("setMembersLoading", true);
    commit("setHasMoreMembers", true);
    var group = this.getters["Group/group"];
    return new Promise(function (resolve, reject) {
      getMembers(group.id, 1).then(function (response) {
        commit("setMembers", response.data.data);

        if (response.data.meta && response.data.meta.pagination) {
          commit("updateMembersPagination", {
            currentPage: response.data.meta.pagination.current_page,
            total_pages: response.data.meta.pagination.total_pages
          });

          if (response.data.meta.pagination.current_page >= response.data.meta.pagination.total_pages) {
            commit("setHasMoreMembers", false);
          }
        } else {
          commit("setHasMoreMembers", false);
        }

        commit("setMembersLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setMembersLoading", false);
        reject();
      });
    });
  },
  fetchMoreMembers: function fetchMoreMembers(_ref13) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var commit, state, group, nextPage, _response$data3, _response$data4, _response$data4$meta, response;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref13.commit, state = _ref13.state;
              group = _this2.getters["Group/group"];

              if (!state.loading.members) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return");

            case 4:
              if (hasNextPage(state, "membersPagination")) {
                _context4.next = 7;
                break;
              }

              commit("setHasMoreMembers", false);
              return _context4.abrupt("return");

            case 7:
              commit("setMembersLoading", true);
              nextPage = state.membersPagination.currentPage + 1;
              _context4.prev = 9;
              _context4.next = 12;
              return getMembers(group.id, nextPage);

            case 12:
              response = _context4.sent;
              commit("appendMembers", Array.isArray((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.data) ? response.data.data : []);
              commitPagination(commit, (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : (_response$data4$meta = _response$data4.meta) === null || _response$data4$meta === void 0 ? void 0 : _response$data4$meta.pagination, {
                update: "updateMembersPagination",
                setHasMore: "setHasMoreMembers"
              });
              commit("setMembersLoading", false);
              _context4.next = 22;
              break;

            case 18:
              _context4.prev = 18;
              _context4.t0 = _context4["catch"](9);
              errorDialog.showErrorMessageFromServer(getErrorPayload(_context4.t0));
              commit("setMembersLoading", false);

            case 22:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[9, 18]]);
    }))();
  },
  createMember: function createMember(_ref14, request) {
    var commit = _ref14.commit;
    commit("setMembersLoading", true);
    var group = this.getters["Group/group"];
    return new Promise(function (resolve, reject) {
      storeMember(group.id, request).then(function () {
        commit("setMembersLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setMembersLoading", false);
        reject();
      });
    });
  },
  updateGroupMember: function updateGroupMember(_ref15, request) {
    var commit = _ref15.commit;
    commit("setParticipantsLoading", true);
    var group = this.getters["Group/group"];
    var userId = request["id"];
    return new Promise(function (resolve, reject) {
      updateMember(group.id, userId, request).then(function () {
        commit("setMembersLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setMembersLoading", false);
        reject();
      });
    });
  },
  removeMember: function removeMember(_ref16, memberId) {
    var commit = _ref16.commit;
    var group = this.getters["Group/group"];
    commit("setMembersLoading", true);
    return new Promise(function (resolve, reject) {
      deleteMember(group.id, memberId).then(function () {
        commit("removeMember", memberId);
        commit("setMembersLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setMembersLoading", false);
        reject();
      });
    });
  },
  // Participants
  fetchMeetingParticipants: function fetchMeetingParticipants(_ref17) {
    var commit = _ref17.commit;
    commit("setParticipantsLoading", true);
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    return new Promise(function (resolve) {
      getParticipants(group.id, meeting.id).then(function (response) {
        commit("setMeetingParticipants", response.data.participants);
        commit("Group/setJobs", response.data.groupJobs.jobs, {
          root: true
        });
        commit("setParticipantsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setParticipantsLoading", false);
      });
    });
  },
  createMeetingParticipant: function createMeetingParticipant(_ref18, request) {
    var commit = _ref18.commit;
    commit("setParticipantsLoading", true);
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    return new Promise(function (resolve, reject) {
      storeParticipant(group.id, meeting.id, request).then(function () {
        commit("setParticipantsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setParticipantsLoading", false);
        reject();
      });
    });
  },
  updateMeetingParticipant: function updateMeetingParticipant(_ref19, request) {
    var commit = _ref19.commit;
    commit("setParticipantsLoading", true);
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    return new Promise(function (resolve, reject) {
      updateParticipant(group.id, meeting.id, request).then(function () {
        commit("setParticipantsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setParticipantsLoading", false);
        reject();
      });
    });
  },
  removeMeetingParticipant: function removeMeetingParticipant(_ref20, participant) {
    var commit = _ref20.commit;
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    commit("setParticipantsLoading", true);
    return new Promise(function (resolve, reject) {
      deleteParticipant(group.id, meeting.id, participant).then(function () {
        commit("removeParticipant", participant);
        commit("setParticipantsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setParticipantsLoading", false);
        reject();
      });
    });
  }
}; // Getter functions

var getters = {
  authUser: function authUser(state) {
    return state.authUser;
  },
  newUser: function newUser(state) {
    return state.newUser;
  },
  user: function user(state, userId) {
    return state.user;
  },
  users: function users(state) {
    return searchByInput(state.users, state.searchUserInput, ["name", "email"]);
  },
  searchUserInput: function searchUserInput(state) {
    return state.searchUserInput;
  },
  members: function members(state) {
    return state.members;
  },
  member: function member(state) {
    return state.member;
  },
  membersLoading: function membersLoading(state) {
    return state.loading.members;
  },
  hasMoreMembers: function hasMoreMembers(state) {
    return state.hasMoreMembers;
  },
  hasMoreUsers: function hasMoreUsers(state) {
    return state.hasMoreUsers;
  },
  nonMembers: function nonMembers(state) {
    return state.users.filter(function (user) {
      return !state.members.find(function (member) {
        return user.email === member.email;
      });
    });
  },
  usersThatAreNotParticipantsYet: function usersThatAreNotParticipantsYet(state) {
    return state.users.filter(function (user) {
      if (!_.isEmpty(state.participants) && state.participants !== null) {
        return !state.participants.find(function (participant) {
          return user.email === participant.email;
        });
      } else {
        return state.users;
      }
    });
  },
  participants: function participants(state) {
    return state.participants;
  },
  participantsLoading: function participantsLoading(state) {
    return state.loading.participants;
  },
  usersLoading: function usersLoading(state) {
    return state.loading.users;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};